var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "failure", staticClass: "failure" }, [
    _c("img", {
      staticStyle: { width: "100%" },
      attrs: { src: "/static/img/shixiao.png", alt: "" }
    }),
    _vm._v(" "),
    _c("p", { staticClass: "text1" }, [
      _vm._v("此链接地址已失效，请重新获取链接!")
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "text2" }, [
      _vm._v(
        "版权所有：深圳市华商数据科技有限公司 Copyright @ 2017 All Rights Reserved"
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85b2fabe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85b2fabe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/conenter/failure.vue
// module id = null
// module chunks = 